export const Update_Success = "Update artefact details succeeded";
